module.exports = __webpack_public_path__ + "media/images/loading-1b696d13.gif";